import type moment from "moment";
import { Component } from "react";

import { cn } from "@btnet/utilities-core";

import { DateDisplay } from "commonComponents/utilities/DateDisplay/DateDisplay";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

interface IDueDateProps {
    date: moment.Moment | undefined;
    linkedScheduleInfo: string | null;
    isPastDue: boolean;
    displayTime: boolean;
    truncateText: boolean;
}

interface IDueDateInternalProps extends Omit<IDueDateProps, "date"> {
    date: moment.Moment;
}

function DueDateInternal(props: IDueDateInternalProps) {
    return (
        <div
            className={cn({
                "text-error": props.isPastDue,
                "text-overflow-auto-child": props.truncateText,
            })}
        >
            <DateDisplay value={props.date} showTime={props.displayTime} />{" "}
            {props.linkedScheduleInfo}
        </div>
    );
}

export class DueDate extends Component<IDueDateProps> {
    static defaultProps = {
        date: undefined,
        linkedScheduleInfo: null,
        isPastDue: false,
        displayTime: false,
    };

    render() {
        const { date, isPastDue } = this.props;
        if (!date) {
            return null;
        }
        const { truncateText } = this.props;

        return (
            <>
                {truncateText && (
                    <TextTruncate className={cn({ "text-error": isPastDue })}>
                        <DueDateInternal {...this.props} date={date} />
                    </TextTruncate>
                )}
                {!truncateText && <DueDateInternal {...this.props} date={date} />}
            </>
        );
    }
}
